import { render, staticRenderFns } from "./BookTransferForm.vue?vue&type=template&id=38d3bab9&"
import script from "./BookTransferForm.vue?vue&type=script&lang=js&"
export * from "./BookTransferForm.vue?vue&type=script&lang=js&"
import style0 from "./BookTransferForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports